module.exports = __webpack_public_path__ + "img/1fie-h-le'ej.96ace26e.jpg";